export default __webpack_public_path__ + "static/media/login_screen.d9f5be0a.png";